import { render, staticRenderFns } from "./DyzPjbg.vue?vue&type=template&id=1da4f253&scoped=true&"
import script from "./DyzPjbg.vue?vue&type=script&lang=js&"
export * from "./DyzPjbg.vue?vue&type=script&lang=js&"
import style0 from "./DyzPjbg.vue?vue&type=style&index=0&id=1da4f253&lang=less&scoped=true&"
import style1 from "./DyzPjbg.vue?vue&type=style&index=1&id=1da4f253&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4f253",
  null
  
)

export default component.exports